var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file"},[_c('p',[_vm._v("Lesson file - "),_c('a',{staticClass:"btn",attrs:{"href":_vm.fileUrl,"download":"","target":"_blank"}},[_vm._v(_vm._s(_vm.title || 'Download'))])])])}
var staticRenderFns = []

export { render, staticRenderFns }